module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/app-layout/app-layout.component.css
// module id = ./src/app/core/components/app-layout/app-layout.component.css
// module chunks = main